export const PUBLIC_TOKEN = 'PUBLIC_TOKEN'
export const PUBLIC_TOKEN_SUCCESS = 'PUBLIC_TOKEN_SUCCESS'
export const PUBLIC_TOKEN_FAILURE = 'PUBLIC_TOKEN_FAILURE'